import api from './api';

export const notificationService = {
  getAll: async () => {
    const res = await api.get('/Notification/GetAll');
    return res.data.data;
  },

  getUnreadCount: async () => {
    const res = await api.get('/Notification/UnreadCount');
    return res.data.data;
  },

  markRead: async (id) => {
    const res = await api.put(`/Notification/MarkRead/${id}`);
    return res.data.data;
  },

  markAllRead: async () => {
    await api.put('/Notification/MarkAllRead');
  },
};
